/**
 * An abstract base class for all models
 */

import { SystemError, IFieldErrorsData, ISystemErrorData } from './error/index';

export abstract class AbstractModel {
  // Note: Type assertion (keyof <T>)[] ensures that the properties
  // that we iterate over are actually valid properties of the data object.
  protected validate<T>(data: T, requiredFields: (keyof T)[]) {
    const invalidFields: IFieldErrorsData = {};

    for (const field of requiredFields) {
      const value = data[field];
      // Explicitly checking the values below to ensure that "0" is treated as valid
      if (
        value === undefined ||
        value === null ||
        // The type of value does not initially overlap type of string so manually check that value is also a string
        (typeof value === 'string' && value == '')
      ) {
        invalidFields[field as string] = [`Missing required property`];
      }
    }
    // Throw error if any invalid fields found
    if (Object.keys(invalidFields).length > 0) {
      const error = new SystemError({
        message: 'Internal Error',
        fieldErrors: invalidFields
      } as ISystemErrorData);

      console.trace(error);

      throw error;
    }
  }
}
